@if (loading && !autoSaveLoading) {
  <div class="row">
    <mat-progress-bar mode="indeterminate" color="primary"></mat-progress-bar>
  </div>
}

@if (autoSaveLoading) {
  <div class="autosave-icon-fixed">
    <mat-icon class="blink">cloud_upload</mat-icon>
  </div>
}

<ng-template #details>
  @if (survey && createMode) {
    <!-- Card EDIT MODE -->
    <mat-card class="my-4 card-details card-details-view">
      <mat-card-header class="card-details-header">
        <mat-card-title class="card-details-title">
          <mat-form-field appearance="fill" class="w-100 title-field-wrapper">
            <mat-label>{{ "generic.title" | translate }}</mat-label>
            <input matInput [(ngModel)]="survey.title" name="survey_title" [ngModelOptions]="{standalone: true}" required>
          </mat-form-field>
        </mat-card-title>
        <mat-chip-grid class="card-details-visibility-pills">
          <mat-chip [ngClass]="survey?.visibility_type === 'PUBLIC' ? 'chip-public' : 'chip-private'" class="text-white">
            @if (survey?.visibility_type === 'PUBLIC') {
              <fa-icon [icon]="faGlobe" class="chip-icon"></fa-icon>
            }
            @if (survey?.visibility_type === 'PRIVATE') {
              <fa-icon [icon]="faLock" class="chip-icon"></fa-icon>
            }
            {{ (survey?.visibility_type === 'PUBLIC' ? 'generic.public' : 'generic.private') | translate }}
          </mat-chip>
        </mat-chip-grid>
      </mat-card-header>
      <mat-card-content class="pb-0">
        <div class="border-top-grey my-2"></div>
        <div class="d-flex justify-content-end align-items-center">
          @if (survey?.updated_at) {
          <div class="autosave-status d-flex align-items-center">
            <fa-icon [icon]="faCheckCircle" class="autosave-check-icon"></fa-icon>
            <span class="grey-color">{{ getLastSavedLabel }}</span>
          </div>
          }
        </div>
        <mat-form-field appearance="fill" class="w-100 description-field-wrapper">
          <mat-label>{{ "generic.description" | translate }}</mat-label>
          <textarea matInput [(ngModel)]="survey.description" name="survey_description" [ngModelOptions]="{standalone: true}"
            placeholder="{{ 'generic.description' | translate }}" cdkTextareaAutosize cdkAutosizeMinRows="3"
            cdkAutosizeMaxRows="8" id="survey_description"></textarea>
        </mat-form-field>
        <div class="row justify-content-center card-details-buttons">
          <div class="col-12 row justify-content-end">
            @if (currentUserInTeam && !survey?.is_draft) {
              <button mat-raised-button color="primary" type="button" class="d-flex align-items-center"
                [routerLink]="['/surveys/'+survey?.id+'/response']">
                {{ (survey.answered ? 'components.responses.view_questionnaire_response' :
                'components.responses.ask-for-response') | translate }}
                <mat-icon iconPositionEnd>chevron_right</mat-icon>
              </button>
            }
            <button mat-stroked-button class="d-flex align-items-center px-4"
              (click)="openSurveyImportModal()">
              <mat-icon class="mr-2">file_copy</mat-icon>
              {{ 'generic.import-survey' | translate }}
            </button>
            <button mat-stroked-button class="d-flex align-items-center px-4" (click)="showEvidences()">
              <mat-icon class="mr-2">attachment</mat-icon>
              {{ 'components.decision-table.new-decision-table.compile-proposal.loaded-evidences' | translate }}
            </button>
          </div>
          <div class="col-12 row justify-content-center">
            @if (survey?.responses?.length > 0 && userService?.userInfo?.id == survey?.created_by_user_id) {
              <button class="btn-custom border-0 d-flex align-items-center px-4" (click)="downloadResponsesCSV()">
                <mat-icon class="mr-2">download</mat-icon>
                {{ 'generic.export-survey-results' | translate }}
              </button>
            }
          </div>
        </div>
      </mat-card-content>
    </mat-card>
  }

    @if (survey && !createMode) {
    <!-- Card VIEW MODE -->
    <mat-card class="my-4 card-details card-details-view border-primary">
      <mat-card-header class="card-details-header">
        <mat-card-title class="card-details-title d-flex align-items-center">
          <fa-icon [icon]="faClipboardList" class="card-details-title-icon mr-2"></fa-icon>
          {{survey?.title}}
        </mat-card-title>
        <mat-chip-grid class="card-details-visibility-pills">
          <mat-chip [ngClass]="survey?.visibility_type === 'PUBLIC' ? 'chip-public' : 'chip-private'" class="text-white">
            @if (survey?.visibility_type === 'PUBLIC') {
              <fa-icon [icon]="faGlobe" class="chip-icon"></fa-icon>
            }
            @if (survey?.visibility_type === 'PRIVATE') {
              <fa-icon [icon]="faLock" class="chip-icon"></fa-icon>
            }
            {{ (survey?.visibility_type === 'PUBLIC' ? 'generic.public' : 'generic.private') | translate }}
          </mat-chip>
        </mat-chip-grid>
      </mat-card-header>
      <mat-card-content class="pb-0">
        <div class="border-top-grey my-2"></div>
        <div class="d-flex justify-content-end align-items-center">
          @if (survey?.updated_at) {
          <div class="autosave-status d-flex align-items-center">
            <fa-icon [icon]="faCheckCircle" class="autosave-check-icon"></fa-icon>
            <span class="grey-color">{{ getLastSavedLabel }}</span>
          </div>
          }
        </div>
        <div class="description-field-wrapper">
          <div class="box py-0 px-2 bg-transparent border-0 mb-0">
            <mat-label class="box-title p-0 mb-0">{{ "generic.description" | translate }}</mat-label>
          </div>
          <div class="description-input-wrapper">
            <textarea id="survey_description_view" [readonly]="true" [(ngModel)]="survey.description" name="survey_description_view" [ngModelOptions]="{standalone: true}"
              rows="4" class="description-textarea description-textarea-readonly"></textarea>
          </div>
        </div>
        <div class="row justify-content-center card-details-buttons">
          <div class="col-12 row justify-content-end">
            @if (currentUserInTeam) {
              <button mat-raised-button color="primary" type="button" class="d-flex align-items-center"
                [routerLink]="['/surveys/'+survey?.id+'/response']">
                {{ (survey.answered ? 'components.responses.view_questionnaire_response' :
                'components.responses.ask-for-response') | translate }}
                <mat-icon iconPositionEnd>chevron_right</mat-icon>
              </button>
            }
            <button mat-stroked-button class="d-flex align-items-center px-4" (click)="copyLink()">
              <mat-icon class="mr-2">share</mat-icon>
              {{ 'generic.buttons.copy-link' | translate }}
            </button>
            <button mat-stroked-button class="d-flex align-items-center px-4" (click)="openQrDialog()">
              <mat-icon class="mr-2">qr_code</mat-icon>
              QR Code
            </button>
            @if (survey?.responses?.length > 0 && userService?.userInfo?.id == survey?.created_by_user_id) {
              <button mat-stroked-button class="d-flex align-items-center px-4" (click)="downloadResponsesCSV()">
                <mat-icon class="mr-2">download</mat-icon>
                {{ 'generic.export-survey-results' | translate }}
              </button>
            }
            <button mat-stroked-button class="d-flex align-items-center px-4" (click)="showEvidences()">
              <mat-icon class="mr-2">attachment</mat-icon>
              {{ 'components.decision-table.new-decision-table.compile-proposal.loaded-evidences' | translate }}
            </button>
            @if (userService?.userInfo?.id == survey?.created_by_user_id) {
              @if (!hasSurveyAttachmentsToAnalyze) {
                <span class="d-flex align-items-center px-3 text-muted" style="font-size: 0.875rem;">
                  <mat-icon class="mr-1" style="font-size: 18px; height: 18px; width: 18px;">info_outline</mat-icon>
                  {{ 'generic.no-attachments-to-analyze' | translate }}
                </span>
              } @else if (attachmentsAlreadyProcessed && !attachmentAnalysisInProgress) {
                <span class="d-flex align-items-center px-3 text-muted" style="font-size: 0.875rem;">
                  <mat-icon class="mr-1" style="font-size: 18px; height: 18px; width: 18px;">check_circle_outline</mat-icon>
                  {{ 'generic.attachments-already-processed' | translate }}
                </span>
              } @else {
                <button mat-stroked-button class="d-flex align-items-center px-4"
                  [disabled]="triggeringAttachmentAnalysis || attachmentAnalysisInProgress"
                  (click)="triggerAttachmentAnalysis()">
                  @if (triggeringAttachmentAnalysis || attachmentAnalysisInProgress) {
                    <mat-spinner diameter="18" class="mr-2"></mat-spinner>
                  } @else {
                    <mat-icon class="mr-2">attachment</mat-icon>
                  }
                  {{ 'generic.trigger-attachment-analysis' | translate }}
                </button>
              }
            }
          </div>
        </div>
      </mat-card-content>
    </mat-card>
  }

  @if (!createMode && attachmentAnalysisInProgress && userService?.userInfo?.id == survey?.created_by_user_id) {
    <div class="d-flex align-items-center px-3 py-2 my-2 rounded" style="background: #e3f2fd; color: #0d47a1; border: 1px solid #90caf9;">
      <mat-spinner diameter="16" class="mr-2"></mat-spinner>
      <span>{{ 'generic.attachment-analysis-in-progress' | translate }}</span>
    </div>
  }
  @if (!createMode && attachmentsAlreadyProcessed && !attachmentAnalysisInProgress && userService?.userInfo?.id == survey?.created_by_user_id) {
    <div class="d-flex align-items-center px-3 py-2 my-2 rounded" style="background: #e8f5e9; color: #1b5e20; border: 1px solid #a5d6a7;">
      <mat-icon class="mr-2" style="font-size: 18px; height: 18px; width: 18px;">check_circle</mat-icon>
      <span>{{ 'generic.attachment-analysis-already-done' | translate }}</span>
    </div>
  }


  <!-- Pannelli collassabili (allegati AI + visibilità, risposte, …) -->
  <mat-accordion multi class="expansion-panels-cards">
    @if (!createMode && hasSurveyAttachments) {
    <mat-expansion-panel class="expansion-panel-card expansion-panel-attachments"
      (opened)="onSurveyAttachmentsPanelOpened()"
      (closed)="onSurveyAttachmentsPanelClosed()">
      <mat-expansion-panel-header>
        <mat-panel-title>
          <fa-icon [icon]="faPaperclip" class="panel-icon"></fa-icon>
          {{ 'View Attachments Analysis' | translate }}
          @if (surveyProcessedAttachments.length > 0) {
            <span class="survey-attachments-count text-muted ml-1">({{ surveyProcessedAttachments.length }})</span>
          }
        </mat-panel-title>
      </mat-expansion-panel-header>
      <div>
        @if (loadingSurveyAttachments) {
          <mat-progress-bar mode="indeterminate" color="primary" class="mb-3"></mat-progress-bar>
        }
        @if (!loadingSurveyAttachments && surveyProcessedAttachments.length > 0) {
          <div class="mat-elevation-z8 table-container-rounded">
            <div class="table-scroll-wrapper">
              <table mat-table [dataSource]="surveyProcessedAttachments" class="w-100 table-primary attachments-table" multiTemplateDataRows>
                  <!-- Name Column -->
                  <ng-container matColumnDef="name">
                    <th mat-header-cell *matHeaderCellDef class="font-weight-bold">{{ 'generic.name' | translate }}</th>
                    <td mat-cell *matCellDef="let attachment">
                      <div class="d-flex align-items-center">
                        <mat-icon class="mr-2">{{ attachment.type === 'FILE' ? 'insert_drive_file' : 'article' }}</mat-icon>
                        <div>
                          <a [href]="attachment.link || '#'" target="_blank" rel="noopener noreferrer" [class.disabled]="!attachment.link">
                            {{ attachment.name || attachment.title || 'Attachment' }}
                          </a>
                          <br>
                          <small [ngClass]="attachment.doi ? 'text-muted' : 'text-warning'">
                            {{ attachment.doi ? 'DOI: ' + attachment.doi : 'No DOI' }}
                          </small>
                          <!-- @if (attachment.link) {
                            <br>
                            <small class="text-info">{{ attachment.link }}</small>

                          } -->
                        </div>
                      </div>
                    </td>
                  </ng-container>

                  <!-- Type Column -->
                  <ng-container matColumnDef="type">
                    <th mat-header-cell *matHeaderCellDef class="font-weight-bold">{{ 'generic.type' | translate }}</th>
                    <td mat-cell *matCellDef="let attachment">
                      <span class="badge badge-secondary">{{ attachment.type }}</span>
                    </td>
                  </ng-container>

                  <!-- Level Column -->
                  <ng-container matColumnDef="level">
                    <th mat-header-cell *matHeaderCellDef class="font-weight-bold">Level</th>
                    <td mat-cell *matCellDef="let attachment">
                      <span class="badge badge-info">{{ attachment.level || 'N/A' }}</span>
                    </td>
                  </ng-container>

                  <!-- Status Column -->
                  <ng-container matColumnDef="status">
                    <th mat-header-cell *matHeaderCellDef class="font-weight-bold">Status</th>
                    <td mat-cell *matCellDef="let attachment">
                      <span [ngClass]="{
                        'badge': true,
                        'badge-success': attachment.state === 'completed',
                        'badge-warning': attachment.state === 'processing' || attachment.state === 'waiting',
                        'badge-danger': attachment.state === 'failed'
                      }">
                        <mat-icon class="badge-icon" *ngIf="attachment.state === 'processing'">autorenew</mat-icon>
                        <mat-icon class="badge-icon" *ngIf="attachment.state === 'waiting'">schedule</mat-icon>
                        {{ attachment.state }}
                      </span>
                    </td>
                  </ng-container>

                  <!-- Date Column -->
                  <ng-container matColumnDef="date">
                    <th mat-header-cell *matHeaderCellDef class="font-weight-bold">{{ 'generic.date' | translate }}</th>
                    <td mat-cell *matCellDef="let attachment">
                      <small>{{ (attachment.updated_at || attachment.created_at) | date:'short' }}</small>
                    </td>
                  </ng-container>

                  <!-- Analysis Column -->
                  <ng-container matColumnDef="analysis">
                    <th mat-header-cell *matHeaderCellDef class="font-weight-bold">Analysis</th>
                    <td mat-cell *matCellDef="let attachment">
                      @if (attachment.state === 'failed' && attachment.llm_analysis) {
                        <button
                          mat-icon-button
                          color="warn"
                          (click)="toggleSurveyAttachmentExpansion(attachment.id)"
                          matTooltip="View Error Details">
                          <mat-icon>error_outline</mat-icon>
                        </button>
                      } @else if (attachment.analysis || attachment.result || attachment.llm_analysis) {
                        <button
                          mat-icon-button
                          color="primary"
                          (click)="toggleSurveyAttachmentExpansion(attachment.id)"
                          matTooltip="View Details">
                          <mat-icon>{{ expandedSurveyAttachmentId === attachment.id ? 'expand_less' : 'expand_more' }}</mat-icon>
                        </button>
                      } @else {
                        <span class="text-muted">-</span>
                      }
                    </td>
                  </ng-container>

                  <!-- Expanded Detail Row -->
                  <ng-container matColumnDef="expandedDetail">
                    <td mat-cell *matCellDef="let attachment" [attr.colspan]="surveyAttachmentColumns.length">
                      @if (expandedSurveyAttachmentId === attachment.id && (attachment.analysis || attachment.result || attachment.llm_analysis)) {
                        <div class="attachment-detail-expanded p-3">
                          @if (attachment.state === 'failed' && attachment.llm_analysis) {
                            <div class="alert alert-danger mb-2">
                              <strong>Error:</strong> Processing failed
                            </div>
                          }
                          <div class="analysis-content">
                            <markdown [data]="attachment.analysis || attachment.result || attachment.llm_analysis"></markdown>
                          </div>
                        </div>
                      }
                    </td>
                  </ng-container>

                  <tr mat-header-row *matHeaderRowDef="surveyAttachmentColumns"></tr>
                  <tr mat-row *matRowDef="let row; columns: surveyAttachmentColumns"></tr>
                  <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="detail-row"
                    [class.detail-row-collapsed]="expandedSurveyAttachmentId !== row.id"
                    [class.detail-row-expanded]="expandedSurveyAttachmentId === row.id"></tr>
                </table>
            </div>
          </div>
        }
        @if (!loadingSurveyAttachments && surveyProcessedAttachments.length === 0) {
          <div class="p-4">
            <p class="text-muted text-center mb-0">No processed attachments found.</p>
          </div>
        }
      </div>
    </mat-expansion-panel>
    }

    <mat-expansion-panel class="expansion-panel-card" [expanded]="true">
      <mat-expansion-panel-header>
        <mat-panel-title>
          <fa-icon [icon]="faInfoCircle" class="panel-icon"></fa-icon>
          {{'components.survey.visibility' | translate}}
        </mat-panel-title>
      </mat-expansion-panel-header>
      @if (survey) {
      <mat-card>
        <mat-card-content class="survey-settings-readonly-wrapper">
          @if (!createMode) {
          <div class="survey-settings-overlay"></div>
          }
          <mat-radio-group [(ngModel)]="survey.visibility_type" name="visibility_panel" [ngModelOptions]="{standalone: true}"
            (ngModelChange)="handleSurveyChanged()" class="visibility-radio-group">
            <mat-radio-button [value]="'PUBLIC'" class="d-block">
              {{ 'generic.public' | translate }}
            </mat-radio-button>
            <mat-radio-button [value]="'PRIVATE'" class="d-block">
              {{ 'generic.private' | translate }}
            </mat-radio-button>
          </mat-radio-group>
        </mat-card-content>
      </mat-card>
      }
    </mat-expansion-panel>

    <mat-expansion-panel class="expansion-panel-card" [expanded]="true">
      <mat-expansion-panel-header>
        <mat-panel-title>
          <fa-icon [icon]="faClipboardList" class="panel-icon"></fa-icon>
          {{'components.survey.responses' | translate}}
        </mat-panel-title>
      </mat-expansion-panel-header>
      @if (survey) {
      <mat-card>
        <mat-card-content class="survey-settings-readonly-wrapper">
          @if (!createMode) {
          <div class="survey-settings-overlay"></div>
          }
          <div class="d-flex justify-content-between align-items-center py-2">
            <span>{{ 'modals.modal-survey-details.settings.multiple_user_responses_is_enabled_description' | translate }}</span>
            <mat-slide-toggle color="primary" [(ngModel)]="survey.multiple_user_responses_is_enabled" name="multiple_responses" [ngModelOptions]="{standalone: true}"
              (ngModelChange)="handleSurveyChanged()"></mat-slide-toggle>
          </div>
          <div class="d-flex justify-content-between align-items-center py-2">
            <span>{{ 'modals.modal-survey-details.settings.draft_answer_is_enabled_description' | translate }}</span>
            <mat-slide-toggle color="primary" [(ngModel)]="survey.customs.draft_answer_is_enabled" name="draft_enabled" [ngModelOptions]="{standalone: true}"
              (ngModelChange)="handleSurveyChanged()"></mat-slide-toggle>
          </div>
          <div class="d-flex justify-content-between align-items-center py-2">
            <span>{{ 'modals.modal-survey-details.settings.attachments_enabled' | translate }}</span>
            <mat-slide-toggle color="primary" [(ngModel)]="survey.attachments_enabled" name="attachments_enabled" [ngModelOptions]="{standalone: true}"
              (ngModelChange)="handleSurveyChanged()"></mat-slide-toggle>
          </div>
          <div class="d-flex justify-content-between align-items-center py-2">
            <span>{{ 'modals.modal-survey-details.settings.anonymous_survey' | translate }}</span>
            <mat-slide-toggle color="primary" [(ngModel)]="survey.customs.anonymous_survey" name="anonymous_survey" [ngModelOptions]="{standalone: true}"
              (ngModelChange)="handleSurveyChanged()"></mat-slide-toggle>
          </div>
          <div class="d-flex justify-content-between align-items-center py-2">
            <span>{{ 'modals.modal-survey-details.settings.speech_to_text_enabled' | translate }}</span>
            <mat-slide-toggle color="primary" [(ngModel)]="survey.customs.speech_to_text_enabled" name="speech_to_text_enabled" [ngModelOptions]="{standalone: true}"
              (ngModelChange)="onSpeechToTextEnabledChange($event)"></mat-slide-toggle>
          </div>
          @if (survey.customs.speech_to_text_enabled) {
          <div class="d-flex justify-content-between align-items-start py-2">
            <div class="pr-3 flex-grow-1" style="min-width: 0">
              <span>{{ 'modals.modal-survey-details.settings.medical_speech_to_text_enabled' | translate }}</span>
              @if (survey.customs.medical_speech_to_text_enabled) {
                <div class="alert alert-custom alert-custom-info mt-3 mb-0 d-flex align-items-start" role="alert">
                  <mat-icon class="mr-2 mt-1">info</mat-icon>
                  <div>
                    {{ 'modals.modal-survey-details.settings.medical_speech_to_text_english_only' | translate }}
                  </div>
                </div>
              }
            </div>
            <mat-slide-toggle color="primary" [(ngModel)]="survey.customs.medical_speech_to_text_enabled" name="medical_speech_to_text_enabled" [ngModelOptions]="{standalone: true}" class="flex-shrink-0"
              (ngModelChange)="handleSurveyChanged()"></mat-slide-toggle>
          </div>
          }
        </mat-card-content>
      </mat-card>
      }
    </mat-expansion-panel>

    <mat-expansion-panel class="expansion-panel-card" [expanded]="true">
      <mat-expansion-panel-header>
        <mat-panel-title>
          <fa-icon [icon]="faSlidersH" class="panel-icon"></fa-icon>
          {{'components.survey.behavior' | translate}}
        </mat-panel-title>
      </mat-expansion-panel-header>
      @if (survey) {
      <mat-card>
        <mat-card-content class="survey-settings-readonly-wrapper">
          @if (!createMode) {
          <div class="survey-settings-overlay"></div>
          }
          <div class="d-flex justify-content-between align-items-center py-2">
            <span>{{ 'modals.modal-survey-details.settings.skip_introduction_description' | translate }}</span>
            <mat-slide-toggle color="primary" [(ngModel)]="survey.customs.skip_introduction" name="skip_introduction" [ngModelOptions]="{standalone: true}"
              (ngModelChange)="handleSurveyChanged()"></mat-slide-toggle>
          </div>
          @if (email_templates?.length > 0 && createMode) {
            <div class="d-flex justify-content-between align-items-center py-2">
              <span>{{ 'components.decision-table.select-template' | translate }}</span>
              <mat-form-field appearance="outline" class="template-select-inline" subscriptSizing="dynamic">
                <mat-select name="email_template" [(ngModel)]="survey.email_template_id" required [ngModelOptions]="{standalone: true}"
                  (ngModelChange)="handleSurveyChanged()">
                  <mat-option></mat-option>
                  @for (template of email_templates; track template) {
                    <mat-option [value]="template.id">{{ template.name }}</mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </div>
          }
        </mat-card-content>
      </mat-card>
      }
    </mat-expansion-panel>

    @if (survey && !isResponse) {

    <mat-expansion-panel class="expansion-panel-card" [expanded]="true">
      <mat-expansion-panel-header>
        <mat-panel-title>
          <mat-icon class="panel-icon">tune</mat-icon>
          {{ "generic.team-custom-fields" | translate }}
        </mat-panel-title>
      </mat-expansion-panel-header>
      @if (survey) {
      <mat-card>
        <mat-card-content>

          @if (customFieldLoading) {
            <mat-progress-bar mode="indeterminate" color="primary" class="mb-3"></mat-progress-bar>
          }

          <!-- Existing custom fields list -->
          <div class="custom-fields-list mb-3">
            @if (teamMemberCustomFields.length > 0) {
              @for (field of teamMemberCustomFields; track field.id) {
                @if (editingCustomField?.id === field.id) {
                  <!-- Inline edit row -->
                  <div class="custom-field-edit-row">
                    <div class="d-flex align-items-center gap-5">
                      <mat-form-field appearance="outline" subscriptSizing="dynamic" class="flex-grow-1">
                        <mat-label>{{ 'generic.name' | translate }}</mat-label>
                        <input matInput [(ngModel)]="editCustomFieldModel.name" [name]="'edit_cf_name_' + field.id" [ngModelOptions]="{standalone: true}">
                      </mat-form-field>
                      <mat-form-field appearance="outline" subscriptSizing="dynamic" style="width:140px">
                        <mat-label>{{ "generic.type" | translate }}</mat-label>
                        <mat-select [(ngModel)]="editCustomFieldModel.type" [name]="'edit_cf_type_' + field.id" [ngModelOptions]="{standalone: true}">
                          @for (t of customFieldTypes; track t.value) {
                            <mat-option [value]="t.value">{{ t.label }}</mat-option>
                          }
                        </mat-select>
                      </mat-form-field>
                      @if (survey?.visibility_type === 'PUBLIC') {
                        <div class="d-flex align-items-center gap-3">
                          <mat-checkbox [(ngModel)]="editCustomFieldModel.visible" [name]="'edit_cf_visible_' + field.id" [ngModelOptions]="{standalone: true}" color="primary">
                            {{ 'generic.visible' | translate }}
                          </mat-checkbox>
                          <mat-checkbox [(ngModel)]="editCustomFieldModel.required" [name]="'edit_cf_required_' + field.id" [ngModelOptions]="{standalone: true}" color="primary">
                            {{ 'generic.required' | translate }}
                          </mat-checkbox>
                        </div>
                      }
                      <button mat-icon-button color="primary" (click)="saveEditCustomField()" [matTooltip]="'generic.buttons.save' | translate">
                        <mat-icon>check</mat-icon>
                      </button>
                      <button mat-icon-button (click)="cancelEditCustomField()" [matTooltip]="'generic.cancel' | translate">
                        <mat-icon>close</mat-icon>
                      </button>
                    </div>
                  </div>
                } @else {
                  <!-- Read-only row -->
                  <div class="custom-field-row">
                    <div class="field-info">
                      <mat-icon class="text-muted">{{ field.type === 'number' ? 'numbers' : (field.type === 'boolean' ? 'check_box' : (field.type === 'date' ? 'calendar_today' : 'short_text')) }}</mat-icon>
                      <span class="field-name">{{ field.name }}</span>
                      <span class="field-type-badge">{{ field.type | uppercase }}</span>
                      @if (survey?.visibility_type === 'PUBLIC') {
                        @if (field.visible) {
                          <span class="field-tag-badge bg-light-green text-dark-green ml-2">{{ 'generic.visible' | translate }}</span>
                        } @else {
                          <span class="field-tag-badge bg-light-red text-dark-red ml-2">{{ 'generic.hidden' | translate }}</span>
                        }
                        @if (field.required) {
                          <span class="field-tag-badge bg-light-blue text-dark-blue ml-2">{{ 'generic.required' | translate }}</span>
                        }
                      }
                    </div>
                    <div class="field-actions">
                      <button mat-icon-button (click)="startEditCustomField(field)" [matTooltip]="'generic.buttons.modify' | translate">
                        <mat-icon>edit</mat-icon>
                      </button>
                      <button mat-icon-button color="warn" (click)="deleteCustomField(field)" [matTooltip]="'generic.remove' | translate">
                        <mat-icon>delete</mat-icon>
                      </button>
                    </div>
                  </div>
                }
              }
            } @else {
              <div class="p-4 text-center">
                <p class="text-muted small mb-0">{{ "modals.modal-survey-details.no-custom-fields-defined" | translate }}.</p>
              </div>
            }
          </div>

          <!-- Add new custom field form -->
          <div class="add-custom-field-form">
            <div class="form-title">
              <mat-icon>add_circle</mat-icon>
              {{ "modals.modal-survey-details.add-custom-field" | translate }}
            </div>
            <div class="field-group-container">
              <mat-form-field appearance="outline" subscriptSizing="dynamic" class="flex-grow-1">
                <mat-label>{{ "generic.field-name" | translate }}</mat-label>
                <input matInput [(ngModel)]="newCustomField.name" name="new_cf_name" [ngModelOptions]="{standalone: true}" [placeholder]="'modals.modal-survey-details.es-specialization' | translate">
              </mat-form-field>
              <mat-form-field appearance="outline" subscriptSizing="dynamic" style="width:160px">
                <mat-label>{{ "generic.type" | translate }}</mat-label>
                <mat-select [(ngModel)]="newCustomField.type" name="new_cf_type" [ngModelOptions]="{standalone: true}">
                  @for (t of customFieldTypes; track t.value) {
                    <mat-option [value]="t.value">{{ t.label }}</mat-option>
                  }
                </mat-select>
              </mat-form-field>
              @if (survey?.visibility_type === 'PUBLIC') {
                <div class="d-flex align-items-center gap-3 ml-2">
                  <mat-checkbox [(ngModel)]="newCustomField.visible" name="new_cf_visible" [ngModelOptions]="{standalone: true}" color="primary">
                    {{ 'generic.visible' | translate }}
                  </mat-checkbox>
                  <mat-checkbox [(ngModel)]="newCustomField.required" name="new_cf_required" [ngModelOptions]="{standalone: true}" color="primary">
                    {{ 'generic.required' | translate }}
                  </mat-checkbox>
                </div>
              }
            </div>
            <div class="d-flex justify-content-end mt-2">
              <button mat-raised-button color="primary" type="button" (click)="addCustomField()" [disabled]="customFieldLoading">
                <mat-icon class="mr-2">add</mat-icon>
                {{ "generic.add" | translate }}
              </button>
            </div>
          </div>

        </mat-card-content>
      </mat-card>
      }
    </mat-expansion-panel>


      @if (survey && survey?.visibility_type == 'PRIVATE' && (survey?.status !== 'EVALUATING' || survey?.is_draft)) {
    <mat-expansion-panel class="expansion-panel-card" [expanded]="true">
      <mat-expansion-panel-header>
        <mat-panel-title>
          <fa-icon [icon]="faUsers" class="panel-icon"></fa-icon>
          {{ 'generic.team' | translate }}
        </mat-panel-title>
      </mat-expansion-panel-header>
      <mat-card>
        <mat-card-content class="survey-settings-readonly-wrapper survey-team-wrapper">
          <app-team-members-list [members]="survey?.members" [teamMemberCustomFields]="teamMemberCustomFields" />
        </mat-card-content>
      </mat-card>
    </mat-expansion-panel>
      }
    }

  </mat-accordion>
  </ng-template>



  <!-- Pannello delle domande -->
  <ng-template #questions>
    <mat-card class="my-4">
      <mat-card-content>
        <div class="row">
          <div class="col-12 col-lg-6 px-0 mb-0">
            <div class="box py-0 px-2 bg-transparent border-0 mb-0">
              <mat-label class="box-title px-3 mb-0">{{ 'generic.filters' | translate }}</mat-label>
            </div>
          </div>
        </div>
        <div class="row d-flex filters-row">
          <mat-form-field class="select-primary" appearance="fill">
            <mat-label>{{ 'generic.section-filter' | translate }}</mat-label>
            <mat-select name="filter_section" [(ngModel)]="questions_filters.selected_section" [ngModelOptions]="{standalone: true}">
              <mat-option value="">{{ "generic.all" | translate }}</mat-option>
              @for (sec of question_sections; track sec) {
                <mat-option [value]="sec">{{ sec }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
          <mat-checkbox name="filter_only_not_answered" [(ngModel)]="questions_filters.only_not_answered" [ngModelOptions]="{standalone: true}">{{ 'generic.only-answered' |
              translate }}
          </mat-checkbox>
          <mat-checkbox name="filter_accordions_opened" [(ngModel)]="questions_filters.accordions_opened" [ngModelOptions]="{standalone: true}">{{
              'pages.responses.filters.show-all-open' | translate }}
          </mat-checkbox>
        </div>
      </mat-card-content>
    </mat-card>

    @if (questions_filters.only_not_answered && !filteredQuestions?.length) {
    <div class="alert alert-info my-3 text-center" role="alert">
      {{ 'modals.modal-survey-details.no-unanswered-questions' | translate }}
    </div>
    }

    <div cdkDropList (cdkDropListDropped)="createMode ? drop($event) : ''" class="question-list">
      @for (question of filteredQuestions; track question.id) {
      <div class="question-wrapper w-100 mb-3" cdkDrag
        [cdkDragDisabled]="!createMode">

        @if (createMode) {
        <div class="drag-handle" cdkDragHandle>
          <mat-icon>grid_view</mat-icon>
        </div>
        }

        <app-single-question [question]="question" [isDeletable]="this.survey.questions.length > 1"
          (questionDuplicated)="addQuestion($event)" (questionDeleted)="removeQuestion($event)" [editable]="createMode" [survey]="survey" [isResponse]="isResponse" [accordionOpened]="questions_filters.accordions_opened"
          class="question-box w-100" />
      </div>
      }
    </div>

  </ng-template>


  @if ((!loading || autoSaveLoading) && survey) {
  <div class="mb-5">
    <form #form=ngForm (keydown.enter)="$event.preventDefault()" novalidate>

      @if (projectId) {
        @for (section of sections; track section.id; let i = $index) {
        <div class="container-fluid accordion-container">
          <div class="container">
            <mat-accordion class="accordion" multi>
              <mat-expansion-panel expanded>
                <mat-expansion-panel-header>
                  <mat-panel-title>
                    <span class="index">{{ i + 1 }}</span>
                    {{ section.title | translate }}
                  </mat-panel-title>
                </mat-expansion-panel-header>

                @if (section.id === 'DETAILS' && !isResponse) {
                  <ng-template [ngTemplateOutlet]="details"></ng-template>
                }

                @if (section.id === 'QUESTIONS') {
                  <ng-template [ngTemplateOutlet]="questions"></ng-template>
                }
              </mat-expansion-panel>
            </mat-accordion>
          </div>
        </div>
        }
      }

      @if (!projectId) {
        @if (!isResponse) {
          <ng-template [ngTemplateOutlet]="details"></ng-template>
        }
        <ng-template [ngTemplateOutlet]="questions"></ng-template>
      }
    </form>

    @if (!isResponse && createMode) {
    <div class="row justify-content-center my-3">
      <button matButton="filled" color="primary" (click)="addQuestion()">
        {{ 'modals.modal-survey-details.add-question' | translate }}
      </button>
    </div>
    }

    @if (!isResponse && !noButtons) {
      <div class="buttons-container container py-5">
        <button class="button-primary float-left" mat-button (click)="canceled.emit(survey)">
          <i class="icon-Backward-arrow-small"></i>
          {{ "generic.buttons.go-back" | translate }}
        </button>
        <div class="float-right">
          @if (createMode && survey?.is_draft && survey?.id) {
            <button class="button-danger mr-4" (click)="deleteSurvey()" mat-button>
              <i class="icon-cestino"></i>
              <label>
                {{ "generic.delete-survey" | translate }}
              </label>
            </button>
          }
          @if (createMode) {
            <button class="button-primary mr-4" (click)="enablePreviewMode()" mat-button>
              <label>
                {{ "generic.preview" | translate }}
              </label>
            </button>
            <button class="button-primary mr-4"
              (click)="onSubmit(form, surveyService.surveySubmittedTypologies.IS_NEW_DRAFT)" mat-button>
              <label>
                {{ "generic.buttons.save-draft" | translate }}
              </label>
            </button>
            <button class="button-primary float-right" mat-button (click)="onSubmit(form)">
              <i class="icon-Forward-arrow-small"></i>
              <label>
                {{ "generic.buttons.save-and-start" | translate }}
              </label>
            </button>
          }
        </div>
      </div>
    }
  </div>
  }

  @if (previewMode) {
  <div class="anonymize-button" (click)="disablePreviewMode()">
    <span>{{ 'modals.modal-survey-details.exit-from-preview' | translate }}</span>
  </div>
  }

